import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.css']
})
export class SearchResultsComponent implements OnInit {
  accountList: any;
  allocationList: any;
  passportList: any;
  fintrestal_idList: any;
  statusist: any;
  statusList: any;
  acc_no:any;
  passport_no:any;
  finterstal_id:any;
  status:any;
  allocation_status:any;
  searchResults: any;
  cid:any;
  cif_no:any;
  origianl_bank_list: any;
  original_portfolio_list: any;
  login_Details: any;
  FollowUpShow: boolean;
  MarkCompletedShow: boolean;
  WithdrawShow: boolean;
  BlockAccountShow: boolean;

  constructor(private _api:ApiService, private router:Router,  @Inject(SESSION_STORAGE) private storage: StorageService,) { }

  ngOnInit(): void {
    this.FollowUpShow = false;
    this.MarkCompletedShow = false;
    this.WithdrawShow = false;
    this.BlockAccountShow = false;
    this.portfolio_list_get();
    this.bank_list_get();
    this.login_Details = this.getFromLocal("login_Details");

    for(let a  = 0 ; a < this.login_Details.access.length; a ++){
      if(this.login_Details.access[a].title == 'Stop FollowUp' && this.login_Details.access[a].Status ==  true){
        this.FollowUpShow = true;
      }
      if(this.login_Details.access[a].title == 'Mark Completed'  && this.login_Details.access[a].Status ==  true){
        this.MarkCompletedShow = true;
      }
      if(this.login_Details.access[a].title == 'De-activate Account'  && this.login_Details.access[a].Status ==  true){
        this.WithdrawShow = true;
      }
      if(this.login_Details.access[a].title == 'Withdraw Account'  && this.login_Details.access[a].Status ==  true){
        this.BlockAccountShow = true;
      }
    }
  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }

  portfolio_list_get() {
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.portfolio_type_list(a).subscribe(
      (response: any) => {
        this.original_portfolio_list = response.Data;
        // let list = response.Data.reverse();
        // for (let i = 0; i < list.length; i++) {
        //   let obj = { "y": list[i].portfolio_type};
        //   this.portfolio_list.push(obj);
        // }
        // this.booleans = true;
      }
    );
  }


bank_list_get() {
    let a = {
      client_id : this.getFromLocal("Client_ID")
    }
    this._api.fetch_bank_list_by_client_id(a).subscribe(
      (response: any) => {
        this.origianl_bank_list = response.Data;
        // let list = response.Data.reverse();
        // for (let i = 0; i < list.length; i++) {
        //   let obj = { "y": list[i].portfolio_type};
        //   this.portfolio_list.push(obj);
        // }
        // this.booleans = true;
      }
    );
  }

  searchResult(){

  }






  searchFin(){
    this._api.searchbyFint(this.finterstal_id,this.login_Details._id,this.login_Details.designation).subscribe(async data=>{
      if (data['Code'] == 200) {
        this.searchResults = await data['Data'];
        var temp = await data['Data'];
        this.searchResults = [];
        var portfolio_list = this.login_Details.selected_portfolio_list;
        for(let a  = 0 ; a < portfolio_list.length; a++) {
          temp.forEach(element => {
            if(element.porfolio_id == portfolio_list[a]._id){
               this.searchResults.push(element);
            }
          });
        }
      } else {
        this.searchResults = [];
      }
    });
  }

  searchAcc(){
    this._api.searchbyAccount(this.acc_no,this.login_Details._id,this.login_Details.designation).subscribe(async data=>{
      if (data['Code'] == 200) {
        this.searchResults = await data['Data'];
        var temp = await data['Data'];
        this.searchResults = [];
        var portfolio_list = this.login_Details.selected_portfolio_list;
        for(let a  = 0 ; a < portfolio_list.length; a++) {
          temp.forEach(element => {
            if(element.porfolio_id == portfolio_list[a]._id){
               this.searchResults.push(element);
            }
          });
        }
      } else {
        this.searchResults = [];
      }
    });
  }

  searchPass(){
    this._api.searchbyPassport(this.passport_no,this.login_Details._id,this.login_Details.designation).subscribe(async data=>{
      if (data['Code'] == 200) {
        this.searchResults = await data['Data'];
        var temp = await data['Data'];
        this.searchResults = [];
        var portfolio_list = this.login_Details.selected_portfolio_list;
        for(let a  = 0 ; a < portfolio_list.length; a++) {
          temp.forEach(element => {
            if(element.porfolio_id == portfolio_list[a]._id){
               this.searchResults.push(element);
            }
          });
        }
      } else {
        this.searchResults = [];
      }
    });
  }


  searchCIF(){
    this._api.searchbyCIF(this.cif_no).subscribe(async data=>{
      if (data['Code'] == 200) {
        this._api.searchbyFint(data['Data'][0]['CUSTOMER_ID'],this.login_Details._id,this.login_Details.designation).subscribe(async data=>{
          if (data['Code'] == 200) {
            this.searchResults = await data['Data'];
            var temp = await data['Data'];
            this.searchResults = [];
            var portfolio_list = this.login_Details.selected_portfolio_list;
            for(let a  = 0 ; a < portfolio_list.length; a++) {
              temp.forEach(element => {
                if(element.porfolio_id == portfolio_list[a]._id){
                   this.searchResults.push(element);
                }
              });
            }
          } else {
            this.searchResults = [];
          }
        });
      } else {
        this.searchResults = [];
      }
    });
  }


  searchCID(){
    this._api.searchbyCID(this.cid).subscribe(async data=>{
      if (data['Code'] == 200) {
        this._api.searchbyFint(data['Data'][0]['CUSTOMER_ID'],this.login_Details._id,this.login_Details.designation).subscribe(async data=>{
          if (data['Code'] == 200) {
            this.searchResults = await data['Data'];
            var temp = await data['Data'];
            this.searchResults = [];
            var portfolio_list = this.login_Details.selected_portfolio_list;
            for(let a  = 0 ; a < portfolio_list.length; a++) {
              temp.forEach(element => {
                if(element.porfolio_id == portfolio_list[a]._id){
                   this.searchResults.push(element);
                }
              });
            }
          } else {
            this.searchResults = [];
          }
        });
      } else {
        this.searchResults = [];
      }
    });
  }

  getconv(data){
    return JSON.parse(data);
  }

  gotoCustomer(page,data){
    let d = {
      passport_no :  data.passport_no,
      acc_no :  data.acc_no,
      bank_id : data.bank_id,
      portfolio_id :  data.porfolio_id,
      product_id : data.product_id, 
      finterstal_id: data.finterstal_id
    }
    this._api.fetch_customer_detail1(d).subscribe(
      (response: any) => {
        if (response.Data[0].customer_details[0].insert_id != undefined) {
          var test_text = response.Data[0].customer_details;
          var convDatav = test_text;
          var jsonObject = convDatav[0];
          var keyCount  = Object.keys(jsonObject).length;
          // console.log(keyCount);
          let dataList = [];
          for (let i = 0; i < convDatav.length; i++) {
                for (let i = 0; i < keyCount; i++) {
                  var key = Object.keys(jsonObject)[i];
                  if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {
                    
                  } else {
                    var value = jsonObject[key];
                    dataList.push({column:key,row:value});
                  }
                }
              }
            this.storage.set("_storedRecord",{dataList,"keyvalue":data});
            this.router.navigateByUrl(page);
        } else {
          var test_text = JSON.parse(response.Data[0].customer_details[0]);
          var convDatav = test_text;
          var jsonObject = convDatav[0];
          var keyCount  = Object.keys(jsonObject).length;
          // console.log(keyCount);
          let dataList = [];
          for (let i = 0; i < convDatav.length; i++) {
                for (let i = 0; i < keyCount; i++) {
                  var key = Object.keys(jsonObject)[i];
                  if (key == "assigned_by" || key == "Acc_no" || key == "Account_No"  || key == "Bank_ID"  ||  key == "Portfolio_ID"  || key == "") {
                    
                  } else {
                    var value = jsonObject[key];
                    dataList.push({column:key,row:value});
                  }
                }
              }
            this.storage.set("_storedRecord",{dataList,"keyvalue":data});
            this.router.navigateByUrl(page);
        }

    
      }
    );
  }

  selectEvent(item) {
    this.finterstal_id = item._id;
    this.searchResult();
  }

  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }
  
  onFocused(e){
    // do something when input is focused
  }

  stopFollowUp(data){
    Swal.fire({
      title: 'Stop FollowUP',
      text: 'Do you really want to Stop FollowUp for this account',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result)=>{
      if (result.value) {
        this._api.stopFollowUp({acc_no:data.acc_no,stop_follow_up_status:true}).subscribe(data=>{
          if (data['Code']==200) {
            alert(data['Message']);
          } else {
            alert(data['Message']);
          }
        });
      } else {
        
      }
    });
  }

  markCompleted(data){
    Swal.fire({
      title: 'Mark Completed',
      text: 'Do you really want to Mark as Completed for this account',
      icon: 'success',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result)=>{
      if (result.value) {
        this._api.markCompleted({acc_no:data.acc_no,mark_complete_status:true}).subscribe(data=>{
          if (data['Code']==200) {
            alert(data['Message']);
          } else {
            alert(data['Message']);
          }
        });
      } else {
        
      }
    });
  }

  withdrawAccounts(data){
    Swal.fire({
      title: 'Withdraw Account',
      text: 'Do you really want to Withdraw Account this account',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result)=>{
      if (result.value) {
        this._api.withdrawAccount({acc_no:data.acc_no,withdraw_status:true}).subscribe(data=>{
          if (data['Code']==200) {
            alert(data['Message']);
          } else {
            alert(data['Message']);
          }
        });
      } else {
        
      }
    });
  }


  blockAccounts(data){
    Swal.fire({
      title: 'Block Account',
      text: 'Do you really want to Block Account this account',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result)=>{
      if (result.value) {
        this._api.blockAccount({acc_no:data.acc_no,acc_block_status:true}).subscribe(data=>{
          if (data['Code']==200) {
            alert(data['Message']);
          } else {
            alert(data['Message']);
          }
        });
      } else {
        
      }
    });
  }

  // acc_block_status : false,
  // withdraw_status : false,
  // stop_follow_up_status : false,
  // mark_complete_status : false,

}
